export default {
  meta: {
    title: '转化率洞察',
    url: '/brain/conversioninsight', // 埋点用，记录所属模块
    // eventId: 'a7477482-49ae-47ff-bbbb-6c9cd3bfc3d1'
  },
};
